import { render, staticRenderFns } from "./gisbi.vue?vue&type=template&id=bb6e6fd2&scoped=true"
import script from "./gisbi.vue?vue&type=script&lang=js"
export * from "./gisbi.vue?vue&type=script&lang=js"
import style0 from "./gisbi.vue?vue&type=style&index=0&id=bb6e6fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6e6fd2",
  null
  
)

export default component.exports